import React, {} from 'react'
import { Layout } from '../components/Layout'
import { parse } from 'date-fns'
import { summaries, updates } from '../updates'
import { ChangeOverview } from '../components/change_log/change_overview'
import { parseDate } from '../util/dates'

export const ChangeLog = ({}) => {
    return (
        <Layout primary="Change Log">
            <div className="flex flex-col items-center">
                {summaries.map((summary) => (
                    <ChangeOverview
                        key={summary.date}
                        title={summary.title}
                        date={parseDate(summary.date)}
                        updates={summary.updates_filter(updates)}
                    >
                        {summary.description}
                    </ChangeOverview>
                ))}
            </div>
        </Layout>
    )
}
